import { Box, Button, Grid, Snackbar, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const GridContainer = styled(Grid)(() => ({
  padding: '47px 60px 0 160px',
  backgroundColor: '#FAFCFF',
  height: 'auto',
  display: 'flex',
  flexDirection: 'column',
}));

export const TitleBox = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  margin: '0 0 40px 20px',
  alignItems: 'center',
  flexWrap: 'wrap',
  rowGap: '12px',
  gap: '20px',
}));

export const TitleGroup = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '20px',
  flex: '1 1 auto',
  minWidth: 0,
  flexWrap: 'wrap',
  rowGap: '8px',
}));

export const PlaceholderBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '12px',
  height: '78vh',
  minHeight: '500px',
  padding: '20px',
  textAlign: 'center',
  color: '#6b6b6b',
  '& .material-symbols-outlined': {
    fontSize: '48px',
  },
}));

export const OSButton = styled(Button)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  maxWidth: '240px',
  '&:hover': {
    filter: 'brightness(85%)',
  },
}));

export const TVMode = styled(Button)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  width: '150px',
  '&:hover': {
    filter: 'brightness(85%)',
  },
}));

export const PipelineContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  gap: '26px',
  padding: '20px',
  height: '78vh',
  minHeight: '500px',
  overflowX: 'scroll',
  '&::-webkit-scrollbar': {
    height: '15px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: '10px',
    '&:hover': {
      backgroundColor: theme.palette.secondary.dark,
    },
  },
  '&::-webkit-scrollbar-track-piece:start': {
    backgroundColor: 'white',
    borderRadius: '10px',
  },
  '&::-webkit-scrollbar-track': {
    boxShadow: '2px 3px 6px #00000033',
    margin: '0 380px',
    borderRadius: '10px',
  },
  '::-webkit-scrollbar-track-piece:end': {
    backgroundColor: 'white',
    borderRadius: '10px',
  },
}));

export const ScrollTypography = styled(Typography)(() => ({
  color: '#FAFCFF',
}));

export const StyledToast = styled(Snackbar)(() => ({
  '.MuiSnackbarContent-root': { minWidth: 'fit-content' },
}));

export const ToastTypography = styled(Typography)(() => ({
  display: 'flex',
  gap: '4px',
  color: '#FAFCFF',
  '& span': { color: '#62aa41' },
}));
